export default "__VITE_ASSET__F2g94HeS__"